import { POSITIONS_TTL_MS } from '../../utils/query-config';

export function shouldFetchPositions(connection: any): boolean {
  try {
    const last = (connection as any)?.lastPositionsFetch as Date | string | null | undefined;
    const lastDate = last instanceof Date ? last : (last ? new Date(String(last)) : null);
    const positions = ((connection as any)?.positions as unknown[]) || [];
    const cacheWindowMs = POSITIONS_TTL_MS;
    if (lastDate && positions.length > 0 && (Date.now() - lastDate.getTime()) < cacheWindowMs) {
      return false;
    }
    return true;
  } catch {
    return true;
  }
}
